import { Dispatch } from "react";
import styles from "./CartFormCards.module.css";
import { Action } from "../../../Bundles/Types";
import { CartConfigInterface } from "../../CartTypes";
import { FormLayout, Select, TextField } from "@shopify/polaris";
import { FontStyles, HeaderHeightOptions } from "../../../Bundles/constants";
import CustomInputWithUnit from "../../../../components/CustomInputWithUnit/CustomInputWithUnit";
import NewCustomColorPicker from "../../../../components/NewCustomColorPicker/NewCustomColorPicker";

const CartAnnouncementForm = ({
    fields,
    dispatchCartConfig,
    showCartPreview,
}: {
    submit: any;
    fields: any;
    showCartPreview: boolean;
    dispatchCartConfig: Dispatch<Action<CartConfigInterface>>;
}) => {
    const {
        announcement: {
            announcement_message_1,
            announcement_hight,
            // countdown_time_hh,
            countdown_time_mm,
        },
        announcement_design: {
            message_text_color,
            message_bg_color,
            countdown_timer_color,
            message_text_size,
            message_text_style,
            countdown_timer_size,
        },
    } = fields;

    return (
        <>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>General</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <TextField
                            label={"Announcement Text"}
                            placeholder={"Announcement Text"}
                            autoComplete={"off"}
                            helpText={"Use {timer} to show countdown timer"}
                            {...announcement_message_1}
                            onBlur={announcement_message_1?.onBlur}
                            onChange={(val) => {
                                dispatchCartConfig({
                                    payload: {
                                        announcement_message_1: val,
                                    },
                                    isComplex: true,
                                    key: "announcement",
                                });
                                announcement_message_1.onChange(val);
                            }}
                            maxLength={80}
                            showCharacterCount
                        />
                    </div>
                    <div className={`${styles.formRow}`}>
                        <TextField
                            label={"Timer Minutes"}
                            placeholder={"00"}
                            value={countdown_time_mm?.value?.toString()}
                            onBlur={countdown_time_mm?.onBlur}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        countdown_time_mm: Math.min(+value, 60),
                                    },
                                    isComplex: true,
                                    key: "announcement",
                                });
                                countdown_time_mm.onChange(Math.min(+value, 60));
                            }}
                            min={0}
                            max={60}
                            autoComplete="off"
                        />
                    </div>
                    <div className={`${styles.formRow}`}>
                        <Select
                            label={"Container Size"}
                            options={HeaderHeightOptions}
                            placeholder={"Container Size"}
                            onChange={(val) => {
                                announcement_hight.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        announcement_hight: val,
                                    },
                                    isComplex: true,
                                    key: "announcement",
                                });
                            }}
                            value={announcement_hight.value}
                        />
                    </div>
                </FormLayout>
            </div>

            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Color</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={message_bg_color.value}
                            setHexColor={(val) => {
                                message_bg_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        message_bg_color: val,
                                    },
                                    isComplex: true,
                                    key: "announcement_design",
                                });
                            }}
                            label={"Background Color"}
                            props={{
                                ...message_bg_color,
                                onBlur: () => message_bg_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={message_text_color.value}
                            setHexColor={(val) => {
                                message_text_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        message_text_color: val,
                                    },
                                    isComplex: true,
                                    key: "announcement_design",
                                });
                            }}
                            label={"Message Color"}
                            props={{
                                ...message_text_color,
                                onBlur: () => message_text_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={countdown_timer_color.value}
                            setHexColor={(val) => {
                                countdown_timer_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        countdown_timer_color: val,
                                    },
                                    isComplex: true,
                                    key: "announcement_design",
                                });
                            }}
                            label={"Timer Color"}
                            props={{
                                ...countdown_timer_color,
                                onBlur: () => countdown_timer_color?.runValidation(),
                            }}
                        />
                    </div>
                </FormLayout>
            </div>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Typography</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <CustomInputWithUnit
                            min={0}
                            label={"Message Size"}
                            placeholder={"Message size"}
                            setValue={(val) => {
                                message_text_size.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        message_text_size: +val,
                                    },
                                    isComplex: true,
                                    key: "announcement_design",
                                });
                            }}
                            value={message_text_size.value}
                            unitSuffix={"px"}
                            props={{
                                ...message_text_size,
                                onBlur: () => message_text_size?.runValidation(),
                            }}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font style"}
                            onChange={(val) => {
                                message_text_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        message_text_style: val,
                                    },
                                    isComplex: true,
                                    key: "announcement_design",
                                });
                            }}
                            value={message_text_style.value}
                        />
                    </div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <CustomInputWithUnit
                            min={0}
                            label={"Timer Size"}
                            placeholder={"Timer size"}
                            setValue={(val) => {
                                countdown_timer_size.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        countdown_timer_size: +val,
                                    },
                                    isComplex: true,
                                    key: "announcement_design",
                                });
                            }}
                            value={countdown_timer_size.value}
                            unitSuffix={"px"}
                            props={{
                                ...countdown_timer_size,
                                onBlur: () => countdown_timer_size?.runValidation(),
                            }}
                        />
                    </div>
                </FormLayout>
            </div>
        </>
    );
};

export default CartAnnouncementForm;
